import type { BrandedFare } from '@eti/schema-types';
import type { AvailableExtraProductsType, PreSelectedExtraProducts } from '../model';
import { findFareProductById } from '../../utils';
import useFareSelectedProducts from './useFareSelectedProducts';

const useUpdateProductPriceBySelectedFare = (
  preSelectedExtraProducts: PreSelectedExtraProducts[],
  selectedFareKey: string,
  brandedFares: BrandedFare[],
  travelerPricesLength: number,
) => {
  const selectedFare =
    brandedFares.find(({ selectionKey }) => selectionKey === selectedFareKey) || brandedFares[0];
  const { availableExtraProducts } = selectedFare || [];
  const fareProducts = useFareSelectedProducts(
    availableExtraProducts as AvailableExtraProductsType[],
    travelerPricesLength,
  );
  if (fareProducts?.length === 0) {
    return preSelectedExtraProducts;
  }
  const fareProductIds = fareProducts?.map(
    (product: PreSelectedExtraProducts) => product.productId,
  );
  const priceUpdatedProducts = preSelectedExtraProducts?.map(
    (product: PreSelectedExtraProducts) => {
      const fareProduct = findFareProductById(fareProducts, product.productId);
      if (fareProductIds?.includes(product.productId) && fareProduct) {
        const newProduct = {
          ...product,
          price: fareProduct?.price,
          totalPrice: fareProduct?.totalPrice,
        };
        return newProduct;
      }
      return product;
    },
  );
  return priceUpdatedProducts;
};
export default useUpdateProductPriceBySelectedFare;
